<template>
  <div class="al-list-group" test-id="al-list-group">
    <slot />
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss">
.al-list-group {
  box-shadow: 0 8px 4px -4px rgba(54, 64, 63, 0.1);

  .al-list-group-item {
    border: 1px solid color(white, darken, 2);
    border-bottom: 0;

    &:last-child {
      border-bottom: 1px solid color(white, darken, 2);
    }
  }
}
</style>
